import type { LaunchBadge } from '@hibro/shared';
import type { ReactNode } from 'react';

export function ActivityBarBadge({
  badge,
  className = '',
}: {
  badge: LaunchBadge | undefined;
  className?: string;
}): ReactNode {
  if (!badge || (badge.kind === 'count' && badge.count <= 0)) {
    return null;
  }

  if (badge.kind === 'dot') {
    return (
      <span
        aria-label={badge.label}
        className={`pointer-events-none absolute z-10 h-2 w-2 rounded-full bg-red-500 ring-2 ring-(--app-color-bg-surface) ${className}`}
      />
    );
  }

  const max = Math.max(1, badge.max ?? 99);
  const text = badge.count > max ? `${max}+` : String(badge.count);
  return (
    <span
      aria-label={badge.label}
      className={`pointer-events-none absolute z-10 flex h-4 min-w-4 items-center justify-center whitespace-nowrap rounded-full bg-red-500 px-1 text-[10px] font-semibold leading-none text-white ring-2 ring-(--app-color-bg-surface) ${className}`}
    >
      {text}
    </span>
  );
}
